import { render, staticRenderFns } from "./AlterarClassificacao.vue?vue&type=template&id=dd642aee"
import script from "./AlterarClassificacao.vue?vue&type=script&lang=js"
export * from "./AlterarClassificacao.vue?vue&type=script&lang=js"
import style0 from "./AlterarClassificacao.vue?vue&type=style&index=0&id=dd642aee&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports